import React from 'react';
import { isOnPath } from '../../store/apiWrapper';
import ReportSelectionMenu from '../common/reportSelectionMenu';
import Badge from "../layoutItems/badge";
import EntityIdentRow from '../layoutItems/entityIdentRow';

class ReportHeader extends React.Component {
    render() {
        const entityId = window.location.pathname.match(/\d+/)[0];
        const isShortReport = isOnPath({ regex: /report\/short/ });
        const isGlobalReport = isOnPath({ regex: /report\/global/ });

        if (this.props.isMobile) {
            return <EntityIdentRow entityId={entityId} isMobile={true} />;
        }

        return (
            <>
                <ReportSelectionMenu entityId={entityId} />
                <EntityIdentRow entityId={entityId} shadowed={false} sticky={isOnPath({ regex: /\/(((report)\/([\w-]+)))\/(\d+).*/i })} right={this.props.right} />
                {(isShortReport || isGlobalReport) && <Badge entityId={entityId} isShortReport={isShortReport} />}
            </>
        )
    }
}

export default ReportHeader;